<template>
	<div class="grid place-items-start">
		<ClientOnly>
			<Transition name="fade" mode="out-in">
				<DefaultSection
					v-if="isLoading"
					key="loader"
					class="col-start-1 row-start-1"
				>
					<ContentLoader
						class="h-[390px] md:h-[180px] xl:h-[200px]"
					/>
				</DefaultSection>

				<DefaultSection
					v-else-if="activeBanner"
					key="banner"
					class="col-start-1 row-start-1"
				>
					<component :is="activeBanner" />
				</DefaultSection>
			</Transition>
		</ClientOnly>
	</div>
</template>

<script setup>
import ContentLoader from '@/components/ContentLoader.vue'
import DefaultSection from '@/components/sections/DefaultSection.vue'
import { useCampaignsStore } from '@/stores/campaigns'

const campaignsStore = useCampaignsStore()

const isLoading = computed(() => campaignsStore.isLoading)

const activeBanner = computed(() => {
	const key = campaignsStore.getPrimaryCampaignKey
	return getBannerComponent(key)
})
</script>
